// extracted by mini-css-extract-plugin
export default {"Text":"time-bound-filter-warning-module__Text--UTUbu","Box":"time-bound-filter-warning-module__Box--TzNP7"};